import useSignedUrlToGetFile from "../../hooks/useSignedUrlToGetFile";
import { DocumentCarouselFragment } from "../../__generated__/graphql";

interface CarouselItemPreviewProps {
  carouselItem: DocumentCarouselFragment;
  title: string;
  index: number;
  total: number;
}

export default function CarouselItemPreview({
  carouselItem,
  title,
  index,
  total,
}: CarouselItemPreviewProps) {
  const {
    data: signedUrlData,
    loading,
    error,
  } = useSignedUrlToGetFile(carouselItem.bucketKey);
  const fileUrl = signedUrlData?.signedUrlToGetFile;

  const previewDisplay = () => {
    if (!fileUrl) return null;

    if (carouselItem.mimeType.startsWith("video/")) {
      return (
        <video
          src={fileUrl}
          className="w-full h-full rounded-md object-contain"
          controls
        />
      );
    } else if (carouselItem.mimeType.startsWith("image/")) {
      return (
        <img
          src={fileUrl}
          alt={title}
          className="w-full h-full object-contain rounded-md"
        />
      );
    } else {
      return (
        <iframe
          src={fileUrl}
          className="w-full h-full rounded-md"
          style={{ minHeight: "600px" }}
        />
      );
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        Récupération du document {index + 1}/{total}...
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-full text-red-500">
        Erreur: {error.message}
      </div>
    );
  }

  if (!fileUrl) return null;

  return (
    <div className="w-full h-full rounded-md border border-input flex items-center justify-center p-8">
      {previewDisplay()}
    </div>
  );
}
